import { useAtom } from 'jotai';

import { AuditLogPath } from '../routes';

import { atomFromQueryString } from '~/shared/state';

export const $auditLogModuleLocation =
  atomFromQueryString.enum<AuditLogPath>('auditLogPath');

export const useAuditLogLocation = () => {
  const [auditLogPath, setAuditLogPath] = useAtom($auditLogModuleLocation);
  return [auditLogPath, setAuditLogPath] as const;
};
